<div class="app-container">
    <router-outlet></router-outlet>
    <!-- a page waiting for the insights of its workspace after a change says so, over everything -->
    <app-insights-wait></app-insights-wait>
    @if (isWithinApplication() && !smallScreen) {
        <div class="fab-container">
            <button id="help-toggle" mat-fab aria-label="Toggle help information on screen" [color]="helpColor()" (click)="helpButtonClick()" matTooltip="Toggles help information on screen">
                <mat-icon>help</mat-icon>
            </button>
        </div>
    }
</div>

      
